import { Injectable, signal } from "@angular/core";
import { ObjectSpaceService, ObjectTypeInfo } from "@barthauer/abc/core/data";
export enum ObjectTypes {
  Absence = "Absence",
  Account = "Account",
  Address = "Address",
  AddressPerson = "AddressPerson",
  AddressRelation = "AddressRelation",
  AddressResource = "AddressResource",
  ApprovalProcessLib = "ApprovalProcessLib",
  ApprovalRequest = "ApprovalRequest",
  ApprovalStep = "ApprovalStep",
  ApprovalStepLib = "ApprovalStepLib",
  AudAudit = "AudAudit",
  AudAuditItem = "AudAuditItem",
  AudBibCategory = "AudBibCategory",
  AudBibMeasure = "AudBibMeasure",
  AudBibQuestion = "AudBibQuestion",
  AudBibResponse = "AudBibResponse",
  AudLibrary = "AudLibrary",
  AudMeasure = "AudMeasure",
  AudVariant = "AudVariant",
  AudVariantItem = "AudVariantItem",
  Bibliotheque = "Bibliotheque",
  Box = "Box",
  BoxDetail = "BoxDetail",
  BRNLibrary = "BRNLibrary",
  BusinessLine = "BusinessLine",
  BusinessLineLibrary = "BusinessLineLibrary",
  Calendar = "Calendar",
  CalendarDetail = "CalendarDetail",
  CityZIPLibrary = "CityZIPLibrary",
  Comment = "Comment",
  CommonProcess = "CommonProcess",
  CostCentre = "CostCentre",
  CountryLibrary = "CountryLibrary",
  CurrencyConversionLibrary = "CurrencyConversionLibrary",
  CurrencyLibrary = "CurrencyLibrary",
  Department = "Department",
  Document = "Document",
  EditSession = "EditSession",
  Facility = "Facility",
  FacilityGroup = "FacilityGroup",
  GeometryDefinition = "GeometryDefinition",
  KindOfCost = "KindOfCost",
  LocalizedProperty = "LocalizedProperty",
  MailAddress = "MailAddress",
  MailAndWeb = "MailAndWeb",
  MySystem = "MySystem",
  Option = "Option",
  OptionItem = "OptionItem",
  Person = "Person",
  PersonDepartment = "PersonDepartment",
  PhoneNumber = "PhoneNumber",
  Picklist = "Picklist",
  PicklistItem = "PicklistItem",
  Posting = "Posting",
  PostingHistory = "PostingHistory",
  ProcessDetailLibrary = "ProcessDetailLibrary",
  ProcessLibrary = "ProcessLibrary",
  ProcessRole = "ProcessRole",
  ProfitCenter = "ProfitCenter",
  Project = "Project",
  ProjectAddress = "ProjectAddress",
  ProjectBudget = "ProjectBudget",
  ProjectCost = "ProjectCost",
  ProjectCostListing = "ProjectCostListing",
  ProjectMember = "ProjectMember",
  ProjectMemberCapacityDistribution = "ProjectMemberCapacityDistribution",
  ProjectPerson = "ProjectPerson",
  ProjectPhase = "ProjectPhase",
  ProjectPhaseDependency = "ProjectPhaseDependency",
  ProjectPhaseMember = "ProjectPhaseMember",
  ProjectPlan = "ProjectPlan",
  ProjectResource = "ProjectResource",
  ProjectTaskMember = "ProjectTaskMember",
  ProjectTeam = "ProjectTeam",
  Property = "Property",
  PropertyDetailLibrary = "PropertyDetailLibrary",
  PropertyLibrary = "PropertyLibrary",
  Reminder = "Reminder",
  Report = "Report",
  ReportPerson = "ReportPerson",
  ReportPublishedToAddress = "ReportPublishedToAddress",
  Resource = "Resource",
  Selection = "Selection",
  SelectionItem = "SelectionItem",
  StreetLibrary = "StreetLibrary",
  Task = "Task",
  TaskDependency = "TaskDependency",
  TaskLibrary = "TaskLibrary",
  TaskPerson = "TaskPerson",
  Team = "Team",
  TeamMember = "TeamMember",
  TeamMembership = "TeamMembership",
  TeamPerson = "TeamPerson",
  TeamResource = "TeamResource",
  UnitConversionLibrary = "UnitConversionLibrary",
  UnitLibrary = "UnitLibrary",
  WebAddress = "WebAddress",
  xmtAreaOfValidityLibrary = "xmtAreaOfValidityLibrary",
  xmtAssessmentCriteria = "xmtAssessmentCriteria",
  xmtCategoryLibrary = "xmtCategoryLibrary",
  xmtContainerLibrary = "xmtContainerLibrary",
  xmtContainerLibraryLegalObligation = "xmtContainerLibraryLegalObligation",
  xmtCustomerContainer = "xmtCustomerContainer",
  xmtCustomerContainerLegalObligation = "xmtCustomerContainerLegalObligation",
  xmtCustomerDomain = "xmtCustomerDomain",
  xmtCustomerLegal = "xmtCustomerLegal",
  xmtCustomerLegalDomain = "xmtCustomerLegalDomain",
  xmtCustomerLegalObligation = "xmtCustomerLegalObligation",
  xmtCustomerModule = "xmtCustomerModule",
  xmtDamageKindLibrary = "xmtDamageKindLibrary",
  xmtDelegationLetter = "xmtDelegationLetter",
  xmtDelegationLetterObligation = "xmtDelegationLetterObligation",
  xmtDomain = "xmtDomain",
  xmtDomainLegalAssigment = "xmtDomainLegalAssigment",
  xmtLegal = "xmtLegal",
  xmtLegalBasis = "xmtLegalBasis",
  xmtLegalBasisLibrary = "xmtLegalBasisLibrary",
  xmtLegalCrossReference = "xmtLegalCrossReference",
  xmtLegalDomain = "xmtLegalDomain",
  xmtLegalDomainLibrary = "xmtLegalDomainLibrary",
  xmtLegalHistory = "xmtLegalHistory",
  xmtLegalKindLibrary = "xmtLegalKindLibrary",
  xmtLegalObligation = "xmtLegalObligation",
  xmtLegalObligationCategory = "xmtLegalObligationCategory",
  xmtLegalObligationHistory = "xmtLegalObligationHistory",
  xmtLegalSubject = "xmtLegalSubject",
  xmtMeasure = "xmtMeasure",
  xmtMeasureBenefit = "xmtMeasureBenefit",
  xmtMeasureBenefitLibrary = "xmtMeasureBenefitLibrary",
  xmtMeasureDefinition = "xmtMeasureDefinition",
  xmtMeasureDefinitionLibrary = "xmtMeasureDefinitionLibrary",
  xmtMeasureProgress = "xmtMeasureProgress",
  xmtMeasureResource = "xmtMeasureResource",
  xmtMeasureTag = "xmtMeasureTag",
  xmtMeasureTask = "xmtMeasureTask",
  xmtMeasureTaskCollaborator = "xmtMeasureTaskCollaborator",
  xmtMeasureTaskPerson = "xmtMeasureTaskPerson",
  xmtMeasureType = "xmtMeasureType",
  xmtModule = "xmtModule",
  xmtProductLibrary = "xmtProductLibrary",
  xmtReport = "xmtReport",
  xmtResponsiblePlan = "xmtResponsiblePlan",
  xmtRiskAssessmentMeasure = "xmtRiskAssessmentMeasure",
  xmtRiskIssue = "xmtRiskIssue",
  xmtRiskIssueCountry = "xmtRiskIssueCountry",
  xmtRiskIssueCustomerLegalObligation = "xmtRiskIssueCustomerLegalObligation",
  xmtRiskIssueDamageKind = "xmtRiskIssueDamageKind",
  xmtRiskIssuelegalBasis = "xmtRiskIssuelegalBasis",
  xmtRiskIssueProduct = "xmtRiskIssueProduct",
  xmtRiskIssueStandard = "xmtRiskIssueStandard",
  xmtRiskIssueTag = "xmtRiskIssueTag",
  xmtStandardLibrary = "xmtStandardLibrary",
  xmtSubModule = "xmtSubModule",
  xmtSubProject = "xmtSubProject",
  xmtSubProjectEvent = "xmtSubProjectEvent",
  xmtTagLibrary = "xmtTagLibrary",
  xmtUserRolePermission = "xmtUserRolePermission",
  xmtValidityDetailLibrary = "xmtValidityDetailLibrary",
}
@Injectable({
  providedIn: "root",
})
export class ObjectTypeService {
  public ObjectTypesList = signal<{ Name: string; Value: string }[]>([]);
  public ObjectTypesMap = new Map<string, string>();

  constructor(private definitionsEditorService: ObjectSpaceService) {}

  public initializeObjectTypesList() {
    const data = this.definitionsEditorService.getAllObjectTypesInfo();
    if (Array.isArray(data)) {
      data.forEach((x: ObjectTypeInfo) => {
        if (x.Value !== "-1") {
          this.ObjectTypesMap.set(x.Name, x.Value);
        }
      });
    }
  }

  public getObjectTypesValue(name: string): number | undefined {
    return Number(this.ObjectTypesMap.get(name));
  }
}
